import { parseModelWearsContent } from "../../utils/parseModelWearsContent";
import styles from "./ModelWears.scss";

interface ModelWearsProps {
  sizeAndFit?: string;
}

export default function ModelWears({ sizeAndFit }: ModelWearsProps) {
  const parsedContent = parseModelWearsContent(sizeAndFit);

  if (!parsedContent) {
    return null;
  }

  return (
    <div
      className={styles.modelWears}
      data-testid="model-wears"
      dangerouslySetInnerHTML={{ __html: parsedContent }}
    />
  );
}
